import { render, staticRenderFns } from "./inviteMailShare.vue?vue&type=template&id=78b91cee&"
import script from "./inviteMailShare.vue?vue&type=script&lang=js&"
export * from "./inviteMailShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports